import { GroupedFilter as GroupedFilterType } from 'module/types/filter-field/grouped-filter/filter';
import { isFieldFilterValid } from 'module/types/filter-field/grouped-filter/utils';
import { PageType } from 'api/page-template/types';
import { FC, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { CombinerTypeSelect } from '../components/combiner-type-select';
import { ApiFilterTransformer } from '../filter-transformation/api-filter-transformer';
import { GroupedFilter } from '../grouped-filter';
import { BaseGroupedFilterComponentProps } from '../types';
import { BaseFilterDrawer } from './base-drawer/drawer';

interface Props extends BaseGroupedFilterComponentProps {
  title: string | React.ReactNode;
  visible: boolean;
  onClose: VoidFunction;
  hideRemoveButton?: boolean;
  hasAiQuery?: boolean;
  addButtonText?: string;
  groupedTransformer?: ApiFilterTransformer<GroupedFilterType>;
  pageType?: PageType;
}

const GroupedFilterWrapper = styled.div`
  padding-top: var(--spacing-07);
  height: 100%;
`;

export const GroupedFilterDrawer: FC<Props> = ({
  title,
  filter: value,
  onChange: onSubmit,
  visible,
  onClose,
  fields,
  getFilterOperationTypeOptions,
  getSelectEditorComponents,
  getOperationOptionRenderer,
  userOptionsGetter,
  hideRemoveButton = false,
  hasAiQuery = false,
  groupedTransformer,
  addButtonText,
  pageType,
}) => {
  const [filter, setFilter] = useState(value);

  useEffect(() => {
    setFilter(value);
  }, [value]);

  const onDone = useCallback(() => {
    const validCriteria = filter.groupCriteria.filter(({ criteria }) =>
      isFieldFilterValid(criteria),
    );

    onSubmit({ ...filter, groupCriteria: validCriteria });
  }, [filter, onSubmit]);

  return (
    <BaseFilterDrawer
      title={title}
      onDone={onDone}
      visible={visible}
      onClose={onClose}
      filterComponent={
        <>
          <CombinerTypeSelect
            value={filter.type}
            onChange={(type) => setFilter({ ...filter, type })}
          />
          <GroupedFilterWrapper>
            <GroupedFilter
              fields={fields}
              hideRemoveButton={hideRemoveButton}
              filter={filter}
              onChange={setFilter}
              getFilterOperationTypeOptions={getFilterOperationTypeOptions}
              userOptionsGetter={userOptionsGetter}
              groupedTransformer={groupedTransformer}
              getSelectEditorComponents={getSelectEditorComponents}
              getOperationOptionRenderer={getOperationOptionRenderer}
              hasAiQuery={hasAiQuery}
              addButtonText={addButtonText}
              pageType={pageType}
            />
          </GroupedFilterWrapper>
        </>
      }
    />
  );
};
